var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEventRounded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 8.66634H8.66667C8.3 8.66634 8 8.96634 8 9.33301V11.333C8 11.6997 8.3 11.9997 8.66667 11.9997H10.6667C11.0333 11.9997 11.3333 11.6997 11.3333 11.333V9.33301C11.3333 8.96634 11.0333 8.66634 10.6667 8.66634ZM10.6667 1.99967V2.66634H5.33333V1.99967C5.33333 1.63301 5.03333 1.33301 4.66667 1.33301C4.3 1.33301 4 1.63301 4 1.99967V2.66634H3.33333C2.59333 2.66634 2.00667 3.26634 2.00667 3.99967L2 13.333C2 14.0663 2.59333 14.6663 3.33333 14.6663H12.6667C13.4 14.6663 14 14.0663 14 13.333V3.99967C14 3.26634 13.4 2.66634 12.6667 2.66634H12V1.99967C12 1.63301 11.7 1.33301 11.3333 1.33301C10.9667 1.33301 10.6667 1.63301 10.6667 1.99967ZM12 13.333H4C3.63333 13.333 3.33333 13.033 3.33333 12.6663V5.99967H12.6667V12.6663C12.6667 13.033 12.3667 13.333 12 13.333Z",
    fill: "#004D72"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventRounded);
export default __webpack_public_path__ + "static/media/EventRounded.8fc25311331374f4161d7016126b76aa.svg";
export { ForwardRef as ReactComponent };